module.exports = __webpack_public_path__ + "img/menuLogo.a640f6d7.png";